import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import vuetify from './plugins/vuetify'
import setUpMixins from './utils/mixins'
import cashierConfigs from '@/utils/presets/cashierConfigs'

const addToMixins = {
  Vue,
  router,
  vuetify: vuetify.framework.breakpoint,
  cashierConfigs
}
setUpMixins(addToMixins)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
